module.exports = __webpack_public_path__ + "570ab121e5af16048e82e901a73e19ef.png";